module.exports = __webpack_public_path__ + "img/1567268893.c9207885.jpg";